import { render, staticRenderFns } from "./IconTeaser.vue?vue&type=template&id=be86d84a&scoped=true&"
import script from "./IconTeaser.vue?vue&type=script&lang=js&"
export * from "./IconTeaser.vue?vue&type=script&lang=js&"
import style0 from "./IconTeaser.vue?vue&type=style&index=0&id=be86d84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be86d84a",
  null
  
)

export default component.exports